/* eslint-disable @typescript-eslint/ban-types */
import React, {PureComponent} from 'react';
import classNames from 'classnames';

import EmojiPicker from 'components/emoji_picker';
import EmojiPickerHeader from 'components/emoji_picker/components/emoji_picker_header';
import {type Emoji} from '@mattermost/types/emojis';

type Props = {
    className?: string;
    style?: React.CSSProperties;
    rightOffset?: number;
    topOffset?: number;
    leftOffset?: number;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    customEmojis?: Record<string, any>;
    onEmojiClose: Function;
    onEmojiClick: (emoji: Emoji) => void;
};

type State = {
    filter: string;
}

export default class EmojiPickerTabs extends PureComponent<Props, State> {
    static defaultProps = {
        rightOffset: 0,
        topOffset: 0,
        leftOffset: 0,
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            filter: '',
        };
    }

    handleEmojiPickerClose = () => {
        this.props.onEmojiClose();
    };

    handleFilterChange = (filter: string) => {
        this.setState({filter});
    };

    render() {
        let pickerStyle;
        const {
            onEmojiClick,
            rightOffset,
            style,
            className,
            leftOffset,
            topOffset,
            placement,
        } = this.props;
        if (style && !(style.left === 0 && style.top === 0)) {
            if (placement === 'top' || placement === 'bottom') {
                // Only take the top/bottom position passed by React Bootstrap since we want to be right-aligned
                pickerStyle = {
                    top: style.top,
                    bottom: style.bottom,
                    right: rightOffset,
                };
            } else {
                pickerStyle = {...style};
            }

            pickerStyle.top = pickerStyle.top ? pickerStyle.top + topOffset : topOffset;

            if (pickerStyle.left) {
                pickerStyle.left += leftOffset;
            }
        }

        let pickerClass = 'emoji-picker';
        if (placement === 'bottom') {
            pickerClass += ' bottom';
        }

        return (
            <div
                id='emojiPicker'
                style={pickerStyle}
                className={classNames('a11y__popup', pickerClass, 'emoji-picker--single', className)}
            >
                <EmojiPickerHeader handleEmojiPickerClose={this.handleEmojiPickerClose} />
                <EmojiPicker
                    filter={this.state.filter}
                    onEmojiClick={onEmojiClick}
                    handleFilterChange={this.handleFilterChange}
                />
            </div>
        );
    }
}
